import React from 'react';
import LoginButton from '../components/LoginButton/LoginButton';
import './LandingPage.css';

const LandingPage: React.FC = () => (
  <div className="container text-center d-flex flex-column justify-content-center align-items-center landing-page-container">
    <h1 className="mb-4">Welcome to the Application Portal</h1>
    <p className="lead mb-4">Please log in to view your applications.</p>
    <LoginButton />
  </div>
);

export default LandingPage;
